<div class="mini-statistics d-flex flex-wrap gap-2 mb-4">
  <div class="mini-card p-2">
    <p class="mb-1">{{'LIVE_VIEW.INSIDERS' | translate}}</p>
    <h3 class="mb-0">{{ liveViewData.count ?? 'N/A' }}</h3>
  </div>

  <div class="mini-card p-2">
    <p class="mb-1">{{'LIVE_VIEW.MAX_INSIDERS' | translate}}</p>
    <h3 class="mb-0">{{ settingsData?.maxInsiders ?? 'N/A' }}</h3>
  </div>

  <div class="mini-card p-2">
    <p class="mb-1">{{'LIVE_VIEW.SPACE_LEFT' | translate}}</p>
    <h3 class="mb-0">{{ (settingsData?.maxInsiders - liveViewData.count) ?? 'N/A' }}</h3>
  </div>

  <div class="mini-card p-2">
    <p class="mb-1">{{'LIVE_VIEW.CAPACITY_THRESHOLD_ALERT' | translate}}</p>
    <h3 class="mb-0">{{ settingsData?.alertLimit ?? 'N/A' }}</h3>
  </div>
</div>


<div class="card countr-card mb-4">
  <div class="card-body">
    <h4 class="card-title">{{'LIVE_VIEW.REAL_TIME_OCCUPANCY' | translate}} - <span class="fw-normal">{{ liveViewData.name }}</span></h4>
    <p class="counter text-center fw-bold my-3">{{ liveViewData.count }}</p>
  </div>
  <div class="card-footer p-0">
    <div class="row m-0 fs-3 text-center">
      <div class="col col-6">
        <i class="mdi mdi-chevron-double-up"></i>
        {{'LIVE_VIEW.IN' | translate}}: {{ liveViewData.down }}
      </div>
      <div class="col col-6">
        <i class="mdi mdi-chevron-double-down"></i>
        {{'LIVE_VIEW.OUT' | translate}}: {{ liveViewData.up }}
      </div>
    </div>
  </div>
</div>

<div class="card stretch-card">
  <div class="card-body">
    <h4 class="card-title">{{'LIVE_VIEW.REAL_TIME_VISITS' | translate}} - <span class="fw-normal">{{ liveViewData.name }}</span></h4>
    <div class="my-4 mx-0">
      <div class="d-flex justify-content-between">
        <p class="mb-1">{{ 'LIVE_VIEW.INSIDERS' | translate }}: {{ liveViewData.count ?? 'N/A' }}</p>
        <p class="mb-1">{{ 'LIVE_VIEW.MAX_INSIDERS' | translate }}: {{ settingsData?.maxInsiders ?? 'N/A' }}</p>
      </div>
      <p-progressBar [value]="(liveViewData.count * 100) / settingsData?.maxInsiders"
                     [ngClass]="liveViewData.count >= settingsData?.alertLimit ? 'is-danger' : 'is-success'"></p-progressBar>
    </div>
    <div class="chart-container mb-2">
      <canvas baseChart
              [type]="chart.type"
              [data]="chart.data"
              [options]="chart.options">
      </canvas>
    </div>
  </div>
</div>
